import { TrailerTemps } from '@asset-solutions/customer-portal/orders/models';

export const orderTempDeviation = (tempSummary: TrailerTemps): { temps: boolean; returnAir: boolean } => {
  const { sensor1, sensor2, sensor3, returnAir1, returnAir2, returnAir3, tempMax, tempMin } = tempSummary;
  const tempDeviation =
    sensor1 > tempMax ||
    sensor1 < tempMin ||
    sensor2 > tempMax ||
    sensor2 < tempMin ||
    sensor3 > tempMax ||
    sensor3 < tempMin;

  const returnAirDeviation =
    returnAir1 > tempMax ||
    returnAir1 < tempMin ||
    returnAir2 > tempMax ||
    returnAir2 < tempMin ||
    returnAir3 > tempMax ||
    returnAir3 < tempMin;

  return { temps: tempDeviation, returnAir: returnAirDeviation };
};
